import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { afterItems, beforeItems } from "../../data/comparison";
export function BeforeAfter() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-114" data-mp="26k9x8i6avbby">
      <div className="mx-auto max-w-5xl" data-id="element-115" data-mp="22lsra1ym86w4">
        <SectionHeading kicker="From scattered references to a clearer assessment workflow" title="What changes when you have a structured system?" data-id="element-116" data-mp="22iy2xzche1xf" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-117" data-mp="2ucqeiqi7qza7">
          <div className="rounded-3xl bg-alert-soft p-5 sm:p-7" data-id="element-118" data-mp="2q9kcxw61pwa2">
            <p className="inline-block rounded-full bg-alert px-4 py-1.5 font-display text-xl font-extrabold uppercase tracking-wide text-white" data-id="element-119" data-mp="2qc6g7jlwlpmh">
              Before
            </p>
            <h3 className="mt-3 font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-120" data-mp="1et3qvjzzkhe8">
              Without a consistent framework
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-121" data-mp="176nra6647rbr">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[17px] leading-snug text-ink" data-id="element-122" data-mp="1c3e5sp29uev2">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert text-white" data-id="element-123" data-mp="y3mmc8szk69o">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-124" data-mp="131xvsifdcerd" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-success-soft p-5 ring-2 ring-success sm:p-7" data-id="element-125" data-mp="t6w7tpwtxiqd">
            <p className="inline-block rounded-full bg-success px-4 py-1.5 font-display text-xl font-extrabold uppercase tracking-wide text-white" data-id="element-126" data-mp="ffrfl8vsjsq2">
              After
            </p>
            <h3 className="mt-3 font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-127" data-mp="5h1xpg3wa89t">
              With Alopecia Clinical Blueprint™
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-128" data-mp="2c40xwwbw1y8r">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[17px] font-medium leading-snug text-ink" data-id="element-129" data-mp="27dkemvldzieh">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-success text-white" data-id="element-130" data-mp="23bfrmfpg1k0t">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-131" data-mp="1ye5q41os5hwm" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-132" data-mp="2r2bc0rrklcy1">
          <p className="text-lg font-semibold text-ink-muted" data-id="element-133" data-mp="2m1nle7796y4c">The transformation is simple:</p>
          <p className="mt-2 font-display text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-134" data-mp="2h45badhi2cur">
            Go from disconnected educational references to a structured system for organizing your
            initial hair loss assessment.
          </p>
        </div>

        <CTAButton className="mt-10" label="Get the complete Alopecia Clinical Blueprint™" note="Just $27 USD · Digital collection" data-id="element-135" data-mp="vkigemmsjzdw" />
      </div>
    </section>;
}